<template>
    <el-tooltip v-bind="$attrs" :disabled="disabled">
        <div slot="content">
            <span style="white-space: pre-wrap;">{{value}}</span>
        </div>
        <div 
            :style="more ? 'white-space: pre-wrap;text-align:left;' : 'text-align:left;'" 
            :class="{'tipContentModal':valueNorm}"
            @click="()=>{ if(valueNorm){more = !more} }">{{showValue}}</div>
    </el-tooltip>
</template>

<script>
export default {
    name:'tipContent',
    props:{
        value:{
            default:null
        }
    },
    data(){
        return{
            more:false
        }
    },
    watch:{
        more(val){
            this.$emit('change',val)
        }
    },
    computed:{
        disabled(){
            if(this.$attrs.disabled) return true
            if(this.value === null) return false
            if(this.more) return true
            return !this.valueNorm
        },
        valueNorm(){
            return this.value && this.value.length && this.value.length > 50
        },
        showValue(){
            return this.more || !this.valueNorm ? this.value : this.value.substring(0,50) + '...'
        }
    }
}
</script>
<style lang="scss">
.tipContentModal{
    cursor: pointer;
    border-radius: 2px;
    transition: all .3s;
    &:hover {
        background-color: rgba(0,0,0,.1);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/common/tipContent.vue